import gql from "graphql-tag";

export const INVITE_NEW_USER = gql`
  mutation ($email: String, $link: String) {
    inviteNewUser(email: $email, link: $link)
  }
`;
